<template>
  <div class="dropdown">
    <transition-group
      class="dropdown__list"
      tag="ul"
      name="flip-list"
    >
      <li
        v-for="(item, index) in dropdownListFiltered"
        :key="item.id"
      >
        <slot
          :item="item"
          :index="index"
        />
      </li>
    </transition-group>

    <transition name="fade">
      <div
        v-if="dropdownList.length > maxVisibleCard"
        class="dropdown__wrap-btn-drop"
      >
        <ButtonDrop :isDropActive.sync="isDropActive" />
      </div>
    </transition>
  </div>
</template>

<script>
import ButtonDrop from '@/components/page/button/ButtonDrop'

export default {
  name: 'Dropdown',
  components: { ButtonDrop },
  props: {
    dropdownList: {
      type: Array,
      required: true
    },
    maxVisibleCard: {
      type: Number,
      default: 6
    }
  },

  data: () => ({
    isDropActive: false
  }),

  computed: {
    dropdownListFiltered () {
      if (this.isDropActive) return this.dropdownList

      return this.dropdownList.slice(0, this.maxVisibleCard)
    }
  }
}
</script>
